import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AudioProvider } from "@/contexts/AudioContext";
import { usePageTracking } from "@/hooks/usePageTracking";
import { useEnsureCountry } from "@/hooks/useEnsureCountry";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import Library from "./pages/Library";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import ChildProfile from "./pages/ChildProfile";
import CreateStory from "./pages/CreateStory";
import StoryPlayer from "./pages/StoryPlayer";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import Refund from "./pages/Refund";
import SubscriptionCallback from "./pages/SubscriptionCallback";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const PageTracker = () => {
  usePageTracking();
  useEnsureCountry();
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AudioProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/home" element={<Home />} />
            <Route path="/library" element={<Library />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/account" element={<Account />} />
            <Route path="/child-profile" element={<ChildProfile />} />
            <Route path="/create" element={<CreateStory />} />
            <Route path="/story/:slug" element={<StoryPlayer />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/subscription/callback" element={<SubscriptionCallback />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AudioProvider>
  </QueryClientProvider>
);

export default App;
